import AttendeeAction from './attendeeAction';
import Attendee from '../../../models/attendeeModel';
import Order from '../../../pages/order/models/orderModel';
import DownloadTicketsActionOrder from '../../../pages/order/actions/downloadTicketsActions';

export default class DownloadTicketAction extends AttendeeAction {
    static NAME = 'download_ticket';

    static condition(attendee) {
        return ['valid'].includes(attendee.order.status) && !attendee.removed && super.payment_plan_condition(attendee);
    }

    static is_attendee_valid({ attendee, order }) {
        return !attendee.removed;
    }

    //global
    get is_direct() {
        return Array.isArray(this.items) && this.items.length > 1;
    }

    get needs_confirm() {
        return false;
    }

    // simple
    get needs_selection() {
        return (Array.isArray(this.items) && this.items.length === 1) || !Array.isArray(this.items);
    }

    run({ orders = null, attendees = null }) {
        if (orders) {
            const to_download = orders.filter(o => DownloadTicketsActionOrder.condition(o));
            return Order.perform_action(DownloadTicketsActionOrder.NAME, to_download, { organization: this.organization, event: this.event });
        }

        return Attendee.perform_action(this.constructor.NAME, attendees || this.filtered_items, { organization: this.organization, event: this.event });
    }

    onActionDone() {
        this.onClose();
    }
}
